import React, { useState } from 'react';
import { Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import { makePayment, generateLetter, deleteAccount } from '../../API';
import { getCurrency, toggleOptionsMenu } from '../../Helper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircle, faSquare } from '@fortawesome/free-regular-svg-icons'
import {
    faCheckCircle, faCheckSquare, faEye, faEdit, faEllipsisH, faEnvelope,
    faMapMarkerAlt, faCity, faUser, faAsterisk, faDollarSign, faBan, faUnlink
} from '@fortawesome/free-solid-svg-icons';
import YesNoModal from '../YesNoModal';

function AccountCard(props) {
    const [deletionConfirmationModal, setDeletionConfirmationModal] = useState(false);

    const toggleDeletionConfirmationModal = () => setDeletionConfirmationModal(!deletionConfirmationModal);

    const defaultOptions = {
        fields: {
            active: true,
            accountNumber: true,
            account: true,
            contact: true,
            address: true,
            email: true,
            balance: true
        },
        actions: {
            view: true,
            edit: true,
            makePayment: true,
            generateLetter: true,
            delete: true,
            select: false,
            cancel: false,
            unlink: false,
        }
    };

    const options = { ...defaultOptions, ...props.options };

    const toggleSelect = () => {
        if (props.selected) {
            props.deselect(props.account.accountID);
        } else {
            props.select(props.account);
        }
    };

    const cancel = () => {
        props.cancel(props.account.accountID);
    };

    const unlink = () => {
        props.unlink(props.account.accountID);
    };

    const createLetter = async () => {
        const generateLetterResult = await generateLetter(props.account.accountID);

        var file = window.URL.createObjectURL(generateLetterResult);
        window.open(file, '_blank');
    };

    const contactName = `${props.account.salutation ? props.account.salutation + ' ' : ''}${props.account.contactFirstName || ''} ${props.account.contactLastName || ''}`;
    const cityStateZip = `${props.account.city || ''}${props.account.city ? ', ' : ''}${props.account.state || ''} ${props.account.zip || ''}`;
    const active = props.account.isActive ? "Active" : "Inactive";
    const activeIcon = props.account.isActive ? (<FontAwesomeIcon icon={faCheckSquare} />) : (<FontAwesomeIcon icon={faSquare} />);

    const viewURL = '/admin/accounts/' + props.account.accountID;
    const editURL = '/admin/accounts/' + props.account.accountID + '/edit';
    const makePaymentURL = '/admin/makepayment?accountId=' + props.account.accountID;
    const letterURL = '/admin/letters?accountId=' + props.account.accountID;

    return (
        <div className="card item-details">
            <div className="properties">
                {options.fields.active ? (
                    <div className="svg-label tooltip-parent">
                        {activeIcon}
                        <span>{active}</span>
                        <div className="tooltip-target tooltip-top">
                            Active
                        </div>
                    </div>
                ) : null}
                {options.fields.accountNumber ? (
                    <div className="svg-label tooltip-parent">
                        <FontAwesomeIcon icon={faAsterisk} />
                        <span>{props.account.accountNumber || ''}</span>
                        <div className="tooltip-target tooltip-top">
                            Account Number
                        </div>
                    </div>
                ) : null}
                {options.fields.account ? (
                    <div className="svg-label tooltip-parent">
                        <FontAwesomeIcon icon={faCity} />
                        <span>{props.account.name || ''}</span>
                        <div className="tooltip-target tooltip-top">
                            Account
                        </div>
                    </div>
                ) : null}
                {options.fields.contact ? (
                    <div className="svg-label tooltip-parent">
                        <FontAwesomeIcon icon={faUser} />
                        <span>{contactName || ''}</span>
                        <div className="tooltip-target tooltip-top">
                            Contact
                        </div>
                    </div>
                ) : null}
                {options.fields.address ? (
                    <div className="svg-label tooltip-parent">
                        <FontAwesomeIcon icon={faMapMarkerAlt} />
                        <span className="full-address">
                            <span>{props.account.address || ''}</span>
                            <span>{cityStateZip || ''}</span>
                        </span>
                        <div className="tooltip-target tooltip-top">
                            Address
                        </div>
                    </div>
                ) : null}
                {options.fields.email ? (
                    <div className="svg-label tooltip-parent">
                        <FontAwesomeIcon icon={faEnvelope} />
                        <span>{props.account.emailAddress || ''}</span>
                        <div className="tooltip-target tooltip-top">
                            Email
                        </div>
                    </div>
                ) : null}
                {options.fields.balance ? (
                    <div className="svg-label tooltip-parent">
                        <FontAwesomeIcon icon={faDollarSign} />
                        <span>{getCurrency(props.account.currentFeeBalance)}</span>
                        <div className="tooltip-target tooltip-top">
                            Balance
                        </div>
                    </div>
                ) : null}
            </div>
            {options.actions ? (
                <div className="actions">
                    {options.actions.view ? (
                        <Link to={viewURL} className="action-icon action-view">
                            <FontAwesomeIcon icon={faEye} />
                            </Link>
                    ) : null}
                    {options.actions.edit && window.env.user.userRoles.some(ur => [1, 2].includes(ur.roleID)) ? (
                        <Link to={editURL} className="action-icon action-edit">
                            <FontAwesomeIcon icon={faEdit} />
                        </Link>
                    ) : null}
                    {options.actions.select ? (
                        <div onClick={toggleSelect} className="action-icon">
                            <FontAwesomeIcon icon={props.selected ? faCheckCircle : faCircle} />
                        </div>
                    ) : null}
                    {options.actions.cancel ? (
                        <div onClick={cancel} className="action-icon action-delete">
                            <FontAwesomeIcon icon={faBan} />
                        </div>
                    ) : null}
                    {options.actions.unlink ? (
                        <div onClick={unlink} className="action-icon action-unlink tooltip-parent">
                            <FontAwesomeIcon icon={faUnlink} />
                            <div className="tooltip-target tooltip-top">
                                Unlink
                            </div>
                        </div>
                    ) : null}
                    {(options.actions.makePayment && window.env.user.userRoles.some(ur => [1, 4].includes(ur.roleID)))
                        || (options.actions.generateLetter && window.env.user.userRoles.some(ur => [1, 3].includes(ur.roleID)))
                        || (options.actions.delete && window.env.user.userRoles.some(ur => [1, 2].includes(ur.roleID))) ? (
                        <div onClick={toggleOptionsMenu} className="action-icon action-dropdown">
                            <FontAwesomeIcon icon={faEllipsisH} />
                            <div className="action-dropdown-menu">
                                {options.actions.makePayment && window.env.user.userRoles.some(ur => [1, 4].includes(ur.roleID)) ? (
                                    <Link className="action-dropdown-menu-item" to={makePaymentURL}><div>Make Payment</div></Link>
                                ) : null}
                                {options.actions.generateLetter && window.env.user.userRoles.some(ur => [1, 3].includes(ur.roleID)) ? (
                                    <Link className="action-dropdown-menu-item" to={letterURL}><span>Send Letter</span></Link>
                                ) : null}
                                {options.actions.delete && window.env.user.userRoles.some(ur => [1, 2].includes(ur.roleID)) ? (
                                    <div className="action-dropdown-menu-item" onClick={toggleDeletionConfirmationModal}><span>Delete</span></div>
                                ) : null}
                            </div>
                        </div>
                    ) : null}
                </div>
            ) : null}
            <YesNoModal title="Confirm Deletion" yesClick={async () => await props.deleteRecord()} open={deletionConfirmationModal} toggle={toggleDeletionConfirmationModal}>Are you sure you want delete this Account?</YesNoModal>
        </div>
    )
}

export default AccountCard;




//<div className="card">
//    <Row>
//        <Col xs={8} md={10}>
//            <Row xs={1} sm={2} lg={3} xl={4}>
//                <Col className="svg-label">
//                    <i className="fas fa-asterisk"></i>
//                    <span>{props.account.accountNumber}</span>
//                </Col>
//                <Col className="svg-label">
//                    <i className="fas fa-city"></i>
//                    <span>{props.account.name}</span>
//                </Col>
//                <Col className="svg-label">
//                    <i className="fas fa-user"></i>
//                    <span>{contactName}</span>
//                </Col>
//                <Col className="svg-label">
//                    <i className="fas fa-map-marker-alt"></i>
//                    <span>{address}</span>
//                </Col>
//                <Col className="svg-label">
//                    <i className="fas fa-envelope"></i>
//                    <span>{props.account.email}</span>
//                </Col>
//                <Col className="svg-label">
//                    <i className="fas fa-dollar-sign"></i>
//                    <span>{props.account.balance}</span>
//                </Col>
//            </Row>
//        </Col>
//        <Col xs={2} md={1}>
//            <Row>
//                <Col className="card-active">
//                    <span>{active}</span>
//                </Col>
//            </Row>
//        </Col>
//        <Col xs={2} md={1}>
//            <Row>
//                <Col xs={12} className="action-icon action-view">
//                    <i className="fas fa-eye"></i>
//                </Col>
//                <Col xs={12} className="action-icon action-edit">
//                    <i className="fas fa-edit"></i>
//                </Col>
//                <Col xs={12} className="action-icon action-delete">
//                    <i className="fas fa-trash-alt"></i>
//                </Col>
//            </Row>
//        </Col>
//    </Row>
//</div>